/* ==========================================================
   LABEL PRIVÉ — SOURCING LUXE
   Catalogue, recherche, fiches modèles et questionnaire
   ========================================================== */
(function () {
  'use strict';

  var LP = (window.LabelPriveSourcing = window.LabelPriveSourcing || {});
  var CACHE_MIN = 20;

  /* ---------- Utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function euro(n) { return Number(n).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €'; }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  /* ---------- Index du catalogue ---------- */
  var cfg = window.LP_SOURCING || {};
  function indexUrl(univers, page, param) {
    var u = (cfg.hubUrl || '/pages/sourcing-luxe') + '?view=sourcing-index-' + univers + '&' + (param || 'page') + '=' + page;
    if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') u += '&preview_theme_id=' + Shopify.theme.id;
    return u;
  }
  function fetchPage(univers, page, param) {
    return fetch(indexUrl(univers, page, param), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var m = t.match(/<!--LPIDX-->([\s\S]*?)<!--\/LPIDX-->/);
        return m ? JSON.parse(m[1]) : { pages: 1, items: [] };
      });
  }
  function loadUnivers(univers) {
    var key = 'lp-idx5-' + univers + '-' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
    var cached = store(key);
    if (cached && Date.now() - cached.at < CACHE_MIN * 60000) return Promise.resolve(cached.items);
    return fetchPage(univers, 1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(fetchPage(univers, p, first.param));
      return Promise.all(rest).then(function (pages) {
        var items = first.items;
        pages.forEach(function (pg) { items = items.concat(pg.items); });
        items.forEach(function (it) { it._q = norm([it.b, it.t, it.m, it.s, it.r, it.c, it.z, (it.mat || []).join(' '), it.g].join(' ')); });
        store(key, { at: Date.now(), items: items });
        return items;
      });
    });
  }
  LP.load = function (list) {
    return Promise.all(list.map(loadUnivers)).then(function (arr) {
      var all = [].concat.apply([], arr);
      all.forEach(function (it) { if (!it._q) it._q = norm([it.b, it.t, it.m, it.s, it.r, it.c, it.z].join(' ')); });
      return all.filter(function (it) { return it.a; });
    });
  };

  /* ---------- Recherche ---------- */
  LP.search = function (items, q) {
    var nq = norm(q);
    if (!nq) return items.slice();
    var tokens = nq.split(' ');
    return items
      .map(function (it) {
        var score = 0;
        for (var i = 0; i < tokens.length; i++) {
          var tk = tokens[i];
          var re = new RegExp('(^| )' + tk.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
          if (re.test(it._q)) score += 2; else if (it._q.indexOf(tk) > -1) score += 1; else return null;
        }
        var ns = norm(it.b + ' ' + it.s), nss = norm(it.s);
        if (ns === nq || nss === nq) score += 20;
        else if (ns.indexOf(nq) === 0 || nss.indexOf(nq) === 0) score += 8;
        if (norm(it.m) === nq || norm(it.b + ' ' + it.m) === nq) score += 6;
        return { it: it, s: score };
      })
      .filter(Boolean)
      .sort(function (a, b) { return b.s - a.s || a.it.o - b.it.o; })
      .map(function (x) { return x.it; });
  };

  /* ---------- Cartes ---------- */
  function placeholder(it, lg) {
    return '<div class="lp-ph' + (lg ? ' lp-ph--lg' : '') + '"><div class="lp-ph__brand">' + esc(it.b) + '</div><div class="lp-ph__model">' + esc(it.s || it.m) + '</div><div class="lp-ph__line"></div></div>';
  }
  LP.placeholder = placeholder;
  function priceLine(min, max) {
    if (!min) return '';
    return 'Prix constaté : ' + euro(min) + (max && max !== min ? ' – ' + euro(max) : '');
  }
  function card(it, opts) {
    opts = opts || {};
    var media = it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + ' – visuel illustratif" loading="lazy" width="700" height="875">' : placeholder(it);
    var meta = opts.meta || priceLine(it.min, it.max);
    return '<a class="lp-card" href="' + esc(opts.url || it.u) + '">' +
      '<div class="lp-card__media">' + media + '<span class="lp-badge">Disponible au sourcing</span></div>' +
      '<p class="lp-card__brand">' + esc(it.b) + '</p>' +
      '<h3 class="lp-card__title">' + esc(opts.title || it.s || it.m) + '</h3>' +
      (meta ? '<p class="lp-card__meta">' + esc(meta) + '</p>' : '') + '</a>';
  }
  function families(items) {
    var map = {}, order = [];
    items.forEach(function (it) {
      var k = it.bh + '|' + it.m;
      if (!map[k]) { map[k] = { first: it, versions: [], min: Infinity, max: 0, img: '' }; order.push(k); }
      var f = map[k];
      f.versions.push(it);
      if (it.min) f.min = Math.min(f.min, it.min);
      if (it.max) f.max = Math.max(f.max, it.max);
      if (!f.img && it.img) f.img = it.img;
      if (it.o < f.first.o) f.first = it;
    });
    return order.map(function (k) { return map[k]; }).sort(function (a, b) { return a.first.o - b.first.o; });
  }
  function familyCard(f) {
    var it = f.first;
    var n = f.versions.length;
    var meta = (n > 1 ? n + ' versions · ' : '') + (f.min < Infinity ? 'dès ' + euro(f.min) : '');
    var fake = { b: it.b, s: it.m, m: it.m, t: it.b + ' ' + it.m, img: f.img, u: it.u };
    return card(fake, { title: it.m, meta: meta, url: it.u });
  }
  LP.card = card;

  /* ---------- HUB ---------- */
  function initHub(root) {
    var input = $('[data-lp-q]', root);
    var results = $('[data-lp-results]', root);
    var grid = $('[data-lp-results-grid]', root);
    var count = $('[data-lp-count]', root);
    var more = $('[data-lp-more]', root);
    var defaults = $$('[data-lp-default]', root);
    var selBrand = $('[data-lp-f="brand"]', root), selCat = $('[data-lp-f="cat"]', root), selGender = $('[data-lp-f="gender"]', root), selBudget = $('[data-lp-f="budget"]', root);
    var tabs = $$('[data-lp-tab]', root);
    var featured = $('[data-lp-featured]', root);
    var state = { u: 'all', limit: 24 };
    var ITEMS = [];

    function setUnivers(u) {
      state.u = u;
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-lp-tab') === u ? 'true' : 'false'); });
      $$('[data-lp-brand-card]', root).forEach(function (el) { el.classList.toggle('lp-hidden', u !== 'all' && el.getAttribute('data-univers') !== u); });
      $$('[data-lp-brand-heading]', root).forEach(function (el) { el.classList.toggle('lp-hidden', u !== 'all' && el.getAttribute('data-univers') !== u); });
      fillSelects();
      run();
    }
    function fillSelects() {
      if (!ITEMS.length) return;
      var pool = ITEMS.filter(function (it) { return state.u === 'all' || it.v === state.u; });
      function fill(sel, key, label) {
        if (!sel) return;
        var cur = sel.value, vals = {};
        pool.forEach(function (it) { if (it[key]) vals[it[key]] = 1; });
        var list = Object.keys(vals).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
        sel.innerHTML = '<option value="">' + label + '</option>' + list.map(function (v) { return '<option' + (v === cur ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('');
      }
      fill(selBrand, 'b', 'Toutes les maisons');
      fill(selCat, 'c', 'Toutes les catégories');
    }
    function active() {
      return norm(input.value) || (selBrand && selBrand.value) || (selCat && selCat.value) || (selGender && selGender.value) || (selBudget && selBudget.value);
    }
    function run() {
      if (!ITEMS.length) return;
      if (!active()) {
        results.classList.add('lp-hidden');
        defaults.forEach(function (d) { d.classList.remove('lp-hidden'); });
        return;
      }
      var list = ITEMS.filter(function (it) {
        if (state.u !== 'all' && it.v !== state.u) return false;
        if (selBrand && selBrand.value && it.b !== selBrand.value) return false;
        if (selCat && selCat.value && it.c !== selCat.value) return false;
        if (selGender && selGender.value && it.g && it.g !== selGender.value && it.g !== 'Unisexe') return false;
        if (selBudget && selBudget.value) {
          var p = selBudget.value.split('-'), lo = +p[0], hi = p[1] ? +p[1] : Infinity;
          if (it.min && (it.min > hi || (it.max || it.min) < lo)) return false;
        }
        return true;
      });
      list = LP.search(list, input.value);
      defaults.forEach(function (d) { d.classList.add('lp-hidden'); });
      results.classList.remove('lp-hidden');
      count.textContent = list.length + (list.length > 1 ? ' modèles disponibles au sourcing' : ' modèle disponible au sourcing');
      grid.innerHTML = list.length ? list.slice(0, state.limit).map(function (it) { return card(it); }).join('') :
        '<div class="lp-empty" style="grid-column:1/-1">Aucun modèle ne correspond encore à votre recherche.<br>Décrivez-nous la pièce souhaitée : <a class="lp-link" href="' + esc(cfg.freeRequestUrl || '/pages/contact') + '">demande libre</a></div>';
      more.classList.toggle('lp-hidden', list.length <= state.limit);
    }
    var t;
    input.addEventListener('input', function () { clearTimeout(t); state.limit = 24; t = setTimeout(run, 120); });
    [selBrand, selCat, selGender, selBudget].forEach(function (s) { if (s) s.addEventListener('change', function () { state.limit = 24; run(); }); });
    tabs.forEach(function (tb) { tb.addEventListener('click', function () { setUnivers(tb.getAttribute('data-lp-tab')); }); });
    $$('[data-lp-go-univers]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        setUnivers(b.getAttribute('data-lp-go-univers'));
        var target = $('#lp-maisons', root); if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
    $$('[data-lp-suggest]', root).forEach(function (b) { b.addEventListener('click', function () { input.value = b.textContent; run(); input.focus(); }); });
    if (more) more.querySelector('button').addEventListener('click', function () { state.limit += 24; run(); });

    var params = new URLSearchParams(location.search);
    if (params.get('q')) input.value = params.get('q');
    if (location.hash === '#montres') state.u = 'montres';

    LP.load(['luxe', 'montres']).then(function (items) {
      ITEMS = items;
      setUnivers(state.u);
      if (featured) {
        var f = items.filter(function (it) { return it.f; }).sort(function (a, b) { return (a.v === b.v ? 0 : a.v === 'luxe' ? -1 : 1) || a.o - b.o; }).slice(0, 8);
        featured.innerHTML = f.map(function (it) { return card(it); }).join('');
      }
    }).catch(function (e) { console.warn('[Sourcing]', e); });
  }

  /* ---------- PAGE MAISON ---------- */
  function initBrand(root) {
    var bh = root.getAttribute('data-bh'), u = root.getAttribute('data-univers');
    var grid = $('[data-lp-families]', root), input = $('[data-lp-q]', root), cat = $('[data-lp-f="cat"]', root), gender = $('[data-lp-f="gender"]', root), count = $('[data-lp-count]', root);
    var ITEMS = [];
    function run() {
      var list = ITEMS.filter(function (it) {
        if (cat && cat.value && it.c !== cat.value) return false;
        if (gender && gender.value && it.g && it.g !== gender.value && it.g !== 'Unisexe') return false;
        return true;
      });
      var q = input && norm(input.value);
      if (q) {
        list = LP.search(list, input.value);
        grid.innerHTML = list.map(function (it) { return card(it); }).join('');
        count.textContent = list.length + ' version' + (list.length > 1 ? 's' : '');
      } else {
        var fams = families(list);
        grid.innerHTML = fams.map(familyCard).join('');
        count.textContent = fams.length + ' modèle' + (fams.length > 1 ? 's' : '') + ' · ' + list.length + ' versions';
      }
      if (!list.length) grid.innerHTML = '<div class="lp-empty" style="grid-column:1/-1">Aucun modèle ne correspond à ces critères.</div>';
    }
    LP.load([u]).then(function (items) {
      ITEMS = items.filter(function (it) { return it.bh === bh; }).sort(function (a, b) { return a.o - b.o; });
      if (cat) {
        var cats = {}; ITEMS.forEach(function (it) { if (it.c) cats[it.c] = 1; });
        cat.innerHTML = '<option value="">Toutes les catégories</option>' + Object.keys(cats).sort().map(function (c) { return '<option>' + esc(c) + '</option>'; }).join('');
      }
      run();
    });
    [input, cat, gender].forEach(function (el) { if (el) el.addEventListener(el.tagName === 'INPUT' ? 'input' : 'change', run); });
  }

  /* ---------- FICHE MODÈLE ---------- */
  var ETATS = [
    ['Neuf / jamais porté', 'Jamais utilisé, protections d’origine encore en place, le plus souvent avec boîte, facture et accessoires complets. Pièce rare en seconde main, chiffrée au cas par cas.'],
    ['Excellent état', 'Porté quelques fois seulement. Aucune marque visible, coins et bords intacts, cuir ou boîtier comme neuf, accessoires généralement présents.'],
    ['Très bon état', 'Porté régulièrement mais très bien entretenu. Légères traces d’usage aux coins, aux poignées ou sur le bracelet, rien de marquant à distance de conversation.'],
    ['Bon état', 'Usage visible et assumé : coins frottés, patine du cuir, fines rayures ou micro-taches. Structure, coutures et fermetures parfaitement saines.'],
    ['État vintage / traces d’usage assumées', 'Patine prononcée, marques franches, doublure ou poignées à rafraîchir. Le meilleur rapport prix / pièce iconique, éventuellement à restaurer.'],
    ['Peu importe — privilégier le meilleur rapport qualité/prix', 'Nous comparons tous les grades disponibles et vous proposons la meilleure opportunité du moment.']
  ];
  var ETAT_DELAI = { 'Courant': '7 à 15 jours', 'Recherché': '2 à 4 semaines', 'Rare': '3 à 6 semaines' };
  var PRIORITES = [
    ['Excellent état', 'La qualité de la pièce avant tout.'],
    ['Meilleur prix', 'Le prix le plus serré possible.'],
    ['Meilleur rapport état/prix', 'L’équilibre idéal entre condition et prix.'],
    ['Coloris / finition précise', 'Je veux exactement la version choisie.'],
    ['Année / collection particulière', 'Je recherche une édition spécifique.']
  ];
  var DELAIS = [
    ['Pas d’échéance particulière', 'Nous prenons le temps de trouver la meilleure pièce au meilleur prix.'],
    ['J’ai une date en tête dans le mois', 'Anniversaire, voyage, cadeau : nous priorisons les pièces disponibles rapidement.'],
    ['C’est urgent', 'Nous nous concentrons sur ce qui est immédiatement disponible chez nos partenaires.']
  ];

  function nice(n) {
    if (n < 300) return Math.round(n / 50) * 50;
    if (n < 2000) return Math.round(n / 100) * 100;
    if (n < 10000) return Math.round(n / 500) * 500;
    return Math.round(n / 1000) * 1000;
  }
  LP.brackets = function (min, max, custom) {
    var b;
    if (custom && custom.length >= 2) b = custom.slice().sort(function (x, y) { return x - y; });
    else if (min && max && max > min) {
      b = [nice(min), nice(min + (max - min) * 0.33), nice(min + (max - min) * 0.66), nice(max)];
      b = b.filter(function (v, i) { return v > 0 && b.indexOf(v) === i; });
    } else b = [500, 750, 1000, 1500, 2500];
    var out = [{ label: 'Moins de ' + euro(b[0]), max: b[0] }];
    for (var i = 1; i < b.length; i++) out.push({ label: euro(b[i - 1]).replace(' €', '') + ' – ' + euro(b[i]), max: b[i] });
    out.push({ label: 'Plus de ' + euro(b[b.length - 1]), max: null });
    return out;
  };

  function choiceList(name, list, type) {
    return '<div class="lp-choices">' + list.map(function (c, i) {
      return '<label class="lp-choice"><input type="' + (type || 'radio') + '" name="' + name + '" value="' + esc(c[0]) + '"' + (c[2] ? ' data-max="' + c[2] + '"' : '') + '><span class="lp-choice__box"><span class="lp-choice__t">' + esc(c[0]) + '</span>' + (c[1] ? '<span class="lp-choice__d">' + esc(c[1]) + '</span>' : '') + '</span></label>';
    }).join('') + '</div>';
  }

  function initModel(root) {
    var data = JSON.parse($('[data-lp-model-json]', root).textContent);
    var isWatch = data.univers === 'montres';
    var sel = { matiere: '', coloris: '', option: '' };

    // Galerie
    var mainImg = $('.lp-gallery__main img', root);
    $$('[data-lp-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-lp-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        if (mainImg) { mainImg.src = b.getAttribute('data-src'); }
      });
    });

    // Pastilles de sélection
    $$('[data-lp-pick]', root).forEach(function (group) {
      var key = group.getAttribute('data-lp-pick'), out = $('[data-lp-picked="' + key + '"]', root);
      $$('.lp-pill', group).forEach(function (p) {
        p.addEventListener('click', function () {
          var on = p.getAttribute('aria-pressed') !== 'true';
          $$('.lp-pill', group).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
          sel[key] = on ? p.getAttribute('data-value') : '';
          if (out) out.textContent = sel[key] || 'À préciser';
        });
      });
    });

    // Versions (tailles) de la même famille
    var versions = $('[data-lp-versions]', root);
    if (versions) {
      LP.load([data.univers]).then(function (items) {
        var sib = items.filter(function (it) { return it.bh === data.brandHandle && it.m === data.modele; }).sort(function (a, b) { return a.o - b.o; });
        if (sib.length > 1) {
          $('.lp-pills', versions).innerHTML = sib.map(function (it) {
            var label = it.z && it.z !== 'Taille unique' ? it.z : it.s;
            return '<a class="lp-pill" href="' + esc(it.u) + '"' + (it.h === data.handle ? ' aria-current="page"' : '') + '>' + esc(label) + '</a>';
          }).join('');
          versions.classList.remove('lp-hidden');
        }
      });
    }

    // CTA collant mobile
    var sticky = $('[data-lp-sticky]', root), mainCta = $('[data-lp-open]', root);
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(mainCta);
    }

    // ---------- Questionnaire ----------
    var modal = $('[data-lp-modal]', root);
    var body = $('[data-lp-modal-body]', modal), bar = $('[data-lp-bar]', modal), btnNext = $('[data-lp-next]', modal), btnPrev = $('[data-lp-prev]', modal), stepLabel = $('[data-lp-step-label]', modal);
    var form = $('[data-lp-form]', modal);
    var STEPS = ['etat', 'priorite', 'delai', 'preferences', 'recap', 'contact', 'done'];
    var QNUM = { etat: 1, priorite: 2, delai: 3, preferences: 4 };
    // ---------- Estimation du devis ----------
    var PE = (data.pe || []).map(function (x) { return Number(x) || 0; });
    var HAS_PE = PE.length === 4 && PE[0] > 0;
    var REMISE = (Number(data.remise) || 15) / 100;
    var ETAT_LABELS = ['excellent état', 'très bon état', 'bon état', 'état vintage'];
    var RARETE = data.rarete || 'Courant';
    function r10(n) { return n >= 5000 ? Math.round(n / 50) * 50 : Math.round(n / 10) * 10; }
    function etatIdx(v) {
      for (var i = 0; i < ETATS.length; i++) { if (v === ETATS[i][0]) return (i >= 1 && i <= 4) ? i - 1 : -1; }
      return -1;
    }
    function isNeuf() { return answers.etat === ETATS[0][0]; }
    function market(i) { return PE[i] || 0; }
    function lpPrice(i) { return r10(market(i) * (1 - REMISE)); }
    function devis() {
      if (!HAS_PE || isNeuf()) return null;
      var e = etatIdx(answers.etat);
      if (e >= 0) return { lo: r10(lpPrice(e) * 0.93), hi: r10(lpPrice(e) * 1.07), e: e };
      return { lo: lpPrice(3), hi: lpPrice(0), e: -1 };
    }
    function devisTexte() { var d = devis(); return d ? euro(d.lo) + ' – ' + euro(d.hi) : ''; }
    function delaiAnnonce() { return isNeuf() ? '3 à 6 semaines' : (ETAT_DELAI[RARETE] || ETAT_DELAI.Courant); }
    var cur = 0, answers = {}, sending = false;
    function stepHtml(name) {
      var n = QNUM[name] || 0;
      var head = function (t, s) { return '<p class="lp-q__num">' + (n ? 'Question ' + n + ' / 4' : '') + '</p><h2 class="lp-q__title">' + t + '</h2>' + (s ? '<p class="lp-q__sub">' + s + '</p>' : ''); };
      if (name === 'etat') return head('Quel état recherchez-vous ?', 'Indiquez l’état minimum que vous êtes prêt(e) à accepter. Chaque grade correspond à une fourchette de prix différente : c’est nous qui vous l’annonçons, vous n’avez aucun budget à indiquer.') + choiceList('etat', ETATS);
      if (name === 'priorite') return head('Qu’est-ce qui compte le plus pour vous ?') + choiceList('priorite', PRIORITES);
      if (name === 'delai') {
        return head('Avez-vous une échéance ?', 'Pour ' + (isWatch ? 'une ' : 'un ') + esc(data.sousModele || data.modele) + ', notre délai de recherche habituel est de <strong>' + delaiAnnonce() + '</strong>. Dites-nous si vous avez une contrainte de date.') + choiceList('delai', DELAIS);
      }
      if (name === 'preferences') {
        var f = function (label, nm, val, ph, type) { return '<label class="lp-field"><span class="lp-field__l">' + label + '</span><input class="lp-input" type="' + (type || 'text') + '" name="' + nm + '" value="' + esc(val || '') + '" placeholder="' + esc(ph || '') + '"></label>'; };
        var html = head('Vos préférences', 'Facultatif — plus votre demande est précise, plus notre devis sera juste.');
        if (isWatch) {
          html += '<div class="lp-row">' + f('Référence précise (si connue)', 'reference', data.reference, 'Ex. 126200') + f('Diamètre', 'taille', data.taille, 'Ex. 36 mm') + '</div>' +
            '<div class="lp-row">' + f('Année approximative', 'annee', '', 'Ex. 2018 ou plus récent') + f('Cadran', 'couleur', sel.coloris, 'Ex. bleu, Wimbledon…') + '</div>' +
            '<div class="lp-row">' + f('Bracelet', 'bracelet', sel.option, 'Ex. Jubilé, Oyster…') + f('Boîtier / matière', 'matiere', sel.matiere, 'Ex. acier, acier & or…') + '</div>' +
            '<p class="lp-subhead">Set souhaité</p>' + choiceList('set', [['Full set (boîte + papiers)', ''], ['Montre seule acceptée', ''], ['Peu importe', '']]) +
            '<p class="lp-subhead">Éléments souhaités</p><div class="lp-choices lp-choices--2">' + choiceList('accessoires', [['Boîte', ''], ['Papiers / carte de garantie', ''], ['Facture', ''], ['Maillons supplémentaires', ''], ['Autres accessoires', '']], 'checkbox').replace('<div class="lp-choices">', '').replace(/<\/div>$/, '') + '</div>';
        } else {
          html += '<div class="lp-row">' + f('Couleur', 'couleur', sel.coloris, 'Ex. noir, beige…') + f('Matière', 'matiere', sel.matiere, 'Ex. Monogram, cuir…') + '</div>' +
            '<div class="lp-row">' + f('Taille', 'taille', data.taille, '') + f('Année', 'annee', '', 'Ex. après 2015') + '</div>' +
            f('Collection', 'collection', '', 'Ex. édition limitée, collaboration…') +
            (sel.option ? '<input type="hidden" name="option" value="' + esc(sel.option) + '">' : '') +
            '<p class="lp-subhead">Accessoires souhaités</p><div class="lp-choices lp-choices--2">' + choiceList('accessoires', [['Boîte', ''], ['Dust bag', ''], ['Facture', ''], ['Carte / certificat', ''], ['Autres accessoires', '']], 'checkbox').replace('<div class="lp-choices">', '').replace(/<\/div>$/, '') + '</div>';
        }
        return html + '<label class="lp-field" style="margin-top:2.4rem"><span class="lp-field__l">Informations complémentaires</span><textarea class="lp-textarea" name="commentaires" placeholder="Toute précision utile : détail recherché, usage, occasion…"></textarea></label>';
      }
      if (name === 'recap') return '<p class="lp-q__num">Récapitulatif</p><h2 class="lp-q__title">Votre recherche</h2><p class="lp-q__sub">Vérifiez votre demande avant de recevoir votre devis.</p>' + recapHtml();
      if (name === 'contact') {
        return '<p class="lp-q__num">Dernière étape</p><h2 class="lp-q__title">Où envoyons-nous votre devis ?</h2><p class="lp-q__sub">Vous recevez sous 24 h une fourchette de prix et un délai précis pour cette recherche' + (isNeuf() ? ', établis au cas par cas pour une pièce neuve' : '') + '. Si le devis vous convient, nous vous envoyons les photos des pièces qui correspondent, avec leur état détaillé. Aucun engagement de votre part.</p>' +
          '<div class="lp-row"><label class="lp-field"><span class="lp-field__l">Prénom *</span><input class="lp-input" name="prenom" autocomplete="given-name" required></label><label class="lp-field"><span class="lp-field__l">Nom *</span><input class="lp-input" name="nom" autocomplete="family-name" required></label></div>' +
          '<label class="lp-field"><span class="lp-field__l">E-mail *</span><input class="lp-input" type="email" name="email" autocomplete="email" required></label>' +
          '<div class="lp-row"><label class="lp-field"><span class="lp-field__l">Téléphone</span><input class="lp-input" type="tel" name="telephone" autocomplete="tel"></label><label class="lp-field"><span class="lp-field__l">Ville</span><input class="lp-input" name="ville" autocomplete="address-level2"></label></div>' +
          '<label class="lp-field"><span class="lp-field__l">Pays</span><input class="lp-input" name="pays" autocomplete="country-name" value="France"></label>' +
          '<label class="lp-consent"><input type="checkbox" name="consentement" value="oui" required><span>J’accepte d’être contacté(e) par Label Privé par e-mail, téléphone ou messagerie au sujet de cette recherche de sourcing. *</span></label>' +
          '<label class="lp-consent"><input type="checkbox" name="newsletter" value="oui"><span>Je souhaite également être informé(e) des ventes privées et nouveautés Label Privé (facultatif).</span></label>' +
          '<p class="lp-legal">' + (cfg.legal || '') + '</p>';
      }
      if (name === 'done') {
        return '<div class="lp-done"><p class="lp-q__num">Demande enregistrée</p><h2 class="lp-q__title">Merci ' + esc(answers.prenom || '') + ', votre devis est en préparation.</h2>' +
          '<div class="lp-done__id" data-lp-id>' + esc(answers.id || '') + '</div>' +
          '<p class="lp-q__sub">Vous recevrez sous 24 h' + (answers.email ? ', à l’adresse ' + esc(answers.email) + ',' : '') + ' une fourchette de prix et un délai précis. Pour ce modèle, notre délai de recherche habituel est de <strong>' + delaiAnnonce() + '</strong>. Si le devis vous convient, nous vous enverrons les photos des pièces correspondantes, avec leur état détaillé, avant tout engagement de votre part.</p>' +
          '<a class="lp-btn lp-btn--ghost" href="' + esc(cfg.hubUrl || '/pages/sourcing-luxe') + '">Continuer la découverte</a></div>';
      }
      return '';
    }

    function collect() {
      var fd = new FormData(form);
      fd.forEach(function (v, k) {
        if (k === 'accessoires') return;
        answers[k] = typeof v === 'string' ? v.trim() : v;
      });
      if (!$('input[name="consentement"]:checked', form)) delete answers.consentement;
      if (!$('input[name="newsletter"]:checked', form)) delete answers.newsletter;
      var acc = $$('input[name="accessoires"]:checked', form).map(function (i) { return i.value; });
      if ($('input[name="accessoires"]', form)) answers.accessoires = acc;
    }
    function validate() {
      var name = STEPS[cur], err = '';
      if (['etat', 'priorite', 'delai'].indexOf(name) > -1 && !$('input[name="' + name + '"]:checked', form)) err = 'Merci de sélectionner une réponse.';
      if (name === 'contact') {
        var bad = $$('input[required]', form).filter(function (i) { return i.type === 'checkbox' ? !i.checked : !i.value.trim(); });
        var em = $('input[name="email"]', form);
        if (bad.length) err = 'Merci de compléter les champs obligatoires et d’accepter d’être contacté(e).';
        else if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) err = 'Adresse e-mail invalide.';
      }
      var box = $('[data-lp-error]', modal);
      box.textContent = err;
      return !err;
    }
    function rows() {
      var r = [];
      var push = function (k, v) { if (v && (!Array.isArray(v) || v.length)) r.push([k, Array.isArray(v) ? v.join(', ') : v]); };
      push('État minimum', answers.etat);
      push('Estimation Label Privé', isNeuf() ? 'établie au cas par cas (pièce neuve)' : (devisTexte() ? 'devis attendu entre ' + devisTexte() : ''));
      push('Délai de recherche estimé', delaiAnnonce());
      push('Priorité', answers.priorite);
      push('Échéance', answers.delai);
      push(isWatch ? 'Référence' : 'Taille', isWatch ? answers.reference : answers.taille);
      if (isWatch) push('Diamètre', answers.taille);
      push(isWatch ? 'Cadran' : 'Couleur', answers.couleur);
      push(isWatch ? 'Boîtier' : 'Matière', answers.matiere);
      push('Bracelet', answers.bracelet);
      push('Option', answers.option);
      push('Année', answers.annee);
      push('Collection', answers.collection);
      push('Set', answers.set);
      push(isWatch ? 'Éléments souhaités' : 'Accessoires', answers.accessoires);
      push('Commentaires', answers.commentaires);
      return r;
    }
    function recapHtml() {
      var ver = [answers.matiere, answers.couleur].filter(Boolean).join(' · ');
      return '<div class="lp-recap"><div class="lp-recap__brand">' + esc(data.brand) + '</div><div class="lp-recap__model">' + esc(data.sousModele || data.modele) + '</div>' +
        (ver ? '<p class="lp-recap__ver">' + esc(ver) + '</p>' : '<p class="lp-recap__ver"></p>') +
        '<dl>' + rows().map(function (x) { return '<dt>' + esc(x[0]) + '</dt><dd>' + esc(x[1]) + '</dd>'; }).join('') + '</dl>' +
        '<button type="button" class="lp-edit" data-lp-goto="0">Modifier ma recherche</button></div>';
    }
    function render() {
      var name = STEPS[cur];
      $$('[data-lp-step]', body).forEach(function (s) { s.classList.add('lp-hidden'); });
      var el = $('[data-lp-step="' + name + '"]', body);
      if (!el || name === 'recap' || name === 'done' || name === 'delai' || name === 'contact') {
        if (el) el.remove();
        el = document.createElement('div');
        el.setAttribute('data-lp-step', name);
        el.innerHTML = stepHtml(name);
        form.appendChild(el);
      }
      el.classList.remove('lp-hidden');
      bar.style.width = Math.round((cur / (STEPS.length - 1)) * 100) + '%';
      stepLabel.textContent = data.titre;
      btnPrev.classList.toggle('lp-hidden', cur === 0 || name === 'done');
      $('[data-lp-foot]', modal).classList.toggle('lp-hidden', name === 'done');
      btnNext.textContent = name === 'recap' ? 'Demander mon devis' : name === 'contact' ? 'Recevoir mon devis' : 'Continuer';
      $('[data-lp-error]', modal).textContent = '';
      body.scrollTop = 0;
      $$('[data-lp-goto]', el).forEach(function (b) { b.addEventListener('click', function () { cur = +b.getAttribute('data-lp-goto'); render(); }); });
      // Auto-avance sur les choix uniques
      if (['etat', 'priorite', 'delai'].indexOf(name) > -1) {
        $$('input[type="radio"]', el).forEach(function (i) { i.onchange = function () { setTimeout(next, 220); }; });
      }
    }
    function next() {
      if (sending) return;
      if (!validate()) return;
      collect();
      if (STEPS[cur] === 'contact') return submit();
      cur = Math.min(cur + 1, STEPS.length - 1);
      render();
    }
    function payload() {
      return {
        source: 'site-sourcing-luxe',
        page_url: location.href.split('?')[0],
        univers: isWatch ? 'Montres' : 'Maroquinerie & accessoires',
        handle: data.handle,
        marque: data.brand,
        categorie: data.categorie,
        modele: data.modele,
        sous_modele: data.sousModele,
        taille: answers.taille || data.taille,
        reference: answers.reference || data.reference,
        version: [answers.matiere, answers.option, answers.bracelet].filter(Boolean).join(' / '),
        matiere: answers.matiere || '',
        couleur: answers.couleur || '',
        etat: answers.etat,
        budget_max: '',
        budget_tranche: '',
        priorite: answers.priorite,
        delai: answers.delai,
        annee: answers.annee || '',
        collection: answers.collection || '',
        set: answers.set || '',
        accessoires: (answers.accessoires || []).join(', '),
        commentaires: answers.commentaires || '',
        prenom: answers.prenom, nom: answers.nom, email: answers.email, telephone: answers.telephone, ville: answers.ville, pays: answers.pays,
        consentement: answers.consentement === 'oui' ? 'oui' : 'non',
        newsletter: answers.newsletter === 'oui' ? 'oui' : 'non',
        prix_indicatif: devisTexte(),
        faisabilite: 'Devis à envoyer · Délai annoncé : ' + delaiAnnonce() + ' · Rareté : ' + RARETE + (isNeuf() ? ' · NEUF : à chiffrer au cas par cas' : ''),
        prix_marche_etat: (function () { var e = etatIdx(answers.etat); return HAS_PE && e >= 0 ? market(e) : ''; })(),
        prix_lp_estime: (function () { var e = etatIdx(answers.etat); return HAS_PE && e >= 0 ? lpPrice(e) : ''; })(),
        budget_min_realiste: ''
      };
    }
    function textSummary(p) {
      return ['DEMANDE DE SOURCING ' + (p.id || ''), '', p.marque + ' — ' + p.sous_modele, 'Univers : ' + p.univers]
        .concat(rows().map(function (r) { return r[0] + ' : ' + r[1]; }))
        .concat(['', 'Client : ' + p.prenom + ' ' + p.nom, 'Tél : ' + p.telephone, 'Ville / pays : ' + p.ville + ' / ' + p.pays, 'Consentement contact : ' + p.consentement + ' · Newsletter : ' + p.newsletter, 'Suivi : ' + (p.faisabilite || '—'), 'Page : ' + p.page_url]).join('\n');
    }
    function fallbackId() {
      var d = new Date(), pad = function (n) { return (n < 10 ? '0' : '') + n; };
      return 'LP-SOURCING-W' + String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate()) + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
    }
    function submit() {
      sending = true;
      btnNext.innerHTML = '<span class="lp-spinner"></span>';
      var p = payload();
      var done = function (id, viaSheet) {
        answers.id = id; p.id = id;
        store('lp-last-request', { id: id, prenom: answers.prenom, email: answers.email });
        if (!viaSheet || cfg.alwaysEmail) {
          // Copie de sécurité : formulaire de contact Shopify natif (e-mail à la boutique)
          var cf = document.getElementById('lp-contact-form');
          if (cf) {
            $('[name="contact[email]"]', cf).value = p.email;
            $('[name="contact[name]"]', cf).value = p.prenom + ' ' + p.nom;
            $('[name="contact[phone]"]', cf).value = p.telephone;
            $('[name="contact[body]"]', cf).value = textSummary(p);
            if (!viaSheet) { sessionStorage.setItem('lp-pending-done', '1'); cf.submit(); return; }
            var fd = new FormData(cf); fetch(cf.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
          }
        }
        sending = false;
        cur = STEPS.indexOf('done');
        render();
        if (window.dataLayer) window.dataLayer.push({ event: 'sourcing_request', sourcing_id: id, marque: p.marque, modele: p.sous_modele });
      };
      if (!cfg.endpoint) return done(fallbackId(), false);
      fetch(cfg.endpoint, { method: 'POST', body: JSON.stringify(p), redirect: 'follow' })
        .then(function (r) { return r.json(); })
        .then(function (res) { if (res && res.ok && res.id) done(res.id, true); else throw new Error((res && res.error) || 'Erreur'); })
        .catch(function (e) { console.warn('[Sourcing] endpoint', e); done(fallbackId(), false); });
    }

    function open() {
      modal.classList.add('is-open');
      document.documentElement.classList.add('lp-lock');
      if (cur === STEPS.indexOf('done')) { cur = 0; answers = {}; form.innerHTML = ''; }
      render();
      setTimeout(function () { var f = $('input,button', body); if (f) f.focus({ preventScroll: true }); }, 50);
    }
    function close() { modal.classList.remove('is-open'); document.documentElement.classList.remove('lp-lock'); }
    $$('[data-lp-open]', root).forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-lp-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    btnNext.addEventListener('click', next);
    btnPrev.addEventListener('click', function () { collect(); cur = Math.max(0, cur - 1); render(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); next(); });

    // Retour après le formulaire de contact natif
    if (/contact_posted=true/.test(location.search) && sessionStorage.getItem('lp-pending-done')) {
      sessionStorage.removeItem('lp-pending-done');
      var last = store('lp-last-request') || {};
      answers = { id: last.id, prenom: last.prenom, email: last.email };
      modal.classList.add('is-open'); document.documentElement.classList.add('lp-lock');
      cur = STEPS.indexOf('done'); render();
    }
    if (/[?&]sourcer=1/.test(location.search)) open();
  }

  function boot() {
    $$('[data-lp-hub]').forEach(initHub);
    $$('[data-lp-brand]').forEach(initBrand);
    $$('[data-lp-model]').forEach(initModel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
